import type { Step } from 'react-joyride';

import { OnboardingCohort } from '@/__generated__/graphql.js';

import { MyHiveLocalizationKey } from '../../localization/my-hive.js';

export type LocalizedText = string | MyHiveLocalizationKey;

export type OnboardingStep = Omit<Step, 'title' | 'content'> & {
  id: string;
  flow: Flow;
  title?: LocalizedText;
  content: LocalizedText;
  lastStep?: boolean;
  cohort?: OnboardingCohort;
};

export type Flow = 'GET_FAMILIAR' | 'GROW' | 'PERSONALIZE' | 'MAXIMIZE';

export const getFamiliarSteps: OnboardingStep[] = [
  {
    id: 'sidebar',
    flow: 'GET_FAMILIAR',
    target: '[data-tour="sidebar"]',
    title: MyHiveLocalizationKey.GetFamiliarTitleOne,
    content: MyHiveLocalizationKey.GetFamiliarTextOne,
    placement: 'right-start',
    disableBeacon: true,
  },
  {
    id: 'home',
    flow: 'GET_FAMILIAR',
    target: '[data-tour="main-content"]',
    title: MyHiveLocalizationKey.GetFamiliarTitleTwo,
    content: MyHiveLocalizationKey.GetFamiliarTextTwo,
    placement: 'center',
    disableBeacon: true,
  },
  {
    id: 'cards',
    flow: 'GET_FAMILIAR',
    target: '[data-tour="tiles"]',
    title: MyHiveLocalizationKey.GetFamiliarTitleThree,
    content: MyHiveLocalizationKey.GetFamiliarTextThree,
    placement: 'left-start',
    disableBeacon: true,
  },
];

export const growSteps: OnboardingStep[] = [
  {
    id: 'edit-title',
    cohort: OnboardingCohort.EditTitle,
    flow: 'GROW',
    target: '[data-tour="edit-title"]',
    title: MyHiveLocalizationKey.PersonalizeTitle,
    content: MyHiveLocalizationKey.PersonalizeText,
    placement: 'right',
    disableBeacon: true,
    spotlightClicks: true,
    styles: {
      overlay: {
        cursor: 'default',
      },
    },
  },
  {
    id: 'invite',
    flow: 'GROW',
    target: '[data-tour="invite-tenants"]',
    title: MyHiveLocalizationKey.LetsGrowTitleOne,
    content: MyHiveLocalizationKey.LetsGrowTextOne,
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
    styles: {
      overlay: {
        cursor: 'default',
      },
      spotlight: {
        borderRadius: 9999,
      },
    },
  },
  {
    disableScrolling: false,
    id: 'book',
    flow: 'GROW',
    target: '[data-tour="book-event"]',
    title: MyHiveLocalizationKey.LetsGrowTitleTwo,
    content: MyHiveLocalizationKey.LetsGrowTextTwo,
    placement: 'left',
    disableBeacon: true,
    spotlightClicks: true,
    styles: {
      overlay: {
        cursor: 'default',
      },
    },
  },
  {
    disableScrolling: false,
    id: 'register',
    flow: 'GROW',
    target: '[data-tour="im-interested"]',
    title: MyHiveLocalizationKey.LetsGrowTitleThree,
    content: MyHiveLocalizationKey.LetsGrowextThree,
    placement: 'left',
    disableBeacon: true,
  },
  {
    disableScrolling: false,
    id: 'progress',
    flow: 'GROW',
    target: '[data-tour="progress-card"]',
    title: MyHiveLocalizationKey.LetsGrowTitleFour,
    content: MyHiveLocalizationKey.LetsGrowextFour,
    placement: 'left',
    disableBeacon: true,
    lastStep: true,
  },
];

export const allSteps = [...getFamiliarSteps, ...growSteps];
